import { Routes } from '@angular/router';
import { MasterTabsComponent } from './master-tabs.component';

import { ClientComponent } from './pages/client/client.component';
import { VesselComponent } from './pages/vessel/vessel.component';
import { CargoComponent } from './pages/cargo/cargo.component';
import { PurposeComponent } from './pages/purpose/purpose.component';
import { PortAgentComponent } from './pages/port-agent/port-agent.component';
import { PortComponent } from './pages/port/port.component';
import { TariffServicesComponent } from './pages/tariff-services/tariff-services.component';

export const Masterroutes: Routes = [
  {
    path: '',
    component: MasterTabsComponent,
    children: [
      { path: '', redirectTo: 'tariff-services', pathMatch: 'full' },
      { path: 'tariff-services', component: TariffServicesComponent },
      { path: 'client', component: ClientComponent },
      { path: 'vessel', component: VesselComponent },
      { path: 'cargo', component: CargoComponent },
      { path: 'purpose', component: PurposeComponent },
      { path: 'port-agent', component: PortAgentComponent },
      { path: 'port', component: PortComponent },
      
    ]
  }
];